import React from 'react';
import CustomersSection from '../../../sections/AdminDashboard/UserManagement/Customers';

const Customers = () => {
  return <CustomersSection />;
};

export default Customers;

